import { createSlice } from '@reduxjs/toolkit';
import {
    getTenant,
    updateTenant,
    fetchMembers,
    removeMember,
    createMember,
    setMemberModules,
    uploadSignature,
    deleteSignature,
}  from '../actions/tenant';

export const tenantSlice = createSlice({
    name: 'tenant',
    initialState: {
        loading: false,
        current: [],
        members: [],
        licensedModules: [],
    },
    reducers: {
        resetTenant: (state) => {
            state.current = [];
        }
    },
    extraReducers:(builder) => {
        builder
        // GET TENANT
        .addCase(getTenant.pending,(state) => { state.loading = true })
        .addCase(getTenant.fulfilled,(state, action) => { 
            state.loading = false;
            state.current = action.payload
        })
        .addCase(getTenant.rejected, (state) => { state.loading = false  })
        // UPDATE TENANT
        .addCase(updateTenant.pending,(state) => { state.loading = true })
        .addCase(updateTenant.fulfilled,(state, action) => { 
            state.loading = false;
            state.current = action.payload
        })
        .addCase(updateTenant.rejected, (state) => { state.loading = false  })
        .addCase(fetchMembers.fulfilled, (state, action) => {
            state.members = action.payload.members;
            state.licensedModules = action.payload.licensedModules;
        })
        .addCase(removeMember.fulfilled, (state, action) => {
            state.members = state.members.filter(m => m._id !== action.payload);
        })
        .addCase(createMember.fulfilled, (state, action) => {
            if (!action.payload.invited) {
                state.members.push({ ...action.payload, isOwner: false, modules: action.meta.arg.modules || [] });
            }
        })
        .addCase(setMemberModules.fulfilled, (state, action) => {
            const member = state.members.find(m => m._id === action.payload.userId);
            if (member) member.modules = action.payload.modules;
        })
        .addCase(uploadSignature.pending, (state) => { state.loading = true; })
        .addCase(uploadSignature.fulfilled, (state, action) => {
            state.loading = false;
            state.current = action.payload;
        })
        .addCase(uploadSignature.rejected, (state) => { state.loading = false; })
        .addCase(deleteSignature.pending, (state) => { state.loading = true; })
        .addCase(deleteSignature.fulfilled, (state) => {
            state.loading = false;
            if (state.current) state.current.signature = null;
        })
        .addCase(deleteSignature.rejected, (state) => { state.loading = false; });
    }
});

export const { resetTenant } = tenantSlice.actions;
export default tenantSlice.reducer; 